import {FeatureLaneDefinitionModel} from "data/models/feature-lane";

export const THE_SINGLE_FEATURE_LANE: FeatureLaneDefinitionModel[] = [
  {
    id: "all-features",
    title: "-- No Title single lane --",
    description: "",
    userSurveys: [
      {
        id: "business-info",
        title: "Business information",
        rules: {
          allowsAnonymous: true,
          dependsOn: [],
        },
      }, {
        id: "what-makes-you-special",
        title: "What makes you special?",
        rules: {
          allowsAnonymous: false,
          dependsOn: [
            "business-info",
          ],
        },
      }, {
        id: "visual-recommendations",
        title: "Visual recommendations",
        rules: {
          allowsAnonymous: false,
          dependsOn: [
            "what-makes-you-special",
          ],
        }
      }, {
        id: "your-customers",
        title: "Your customers",
        rules: {
          allowsAnonymous: false,
          dependsOn: [
            "visual-recommendations",
          ],
        }
      }, {
        id: "words-and-messages",
        title: "Words and messages",
        rules: {
          allowsAnonymous: false,
          dependsOn: [
            "visual-recommendations",
          ],
        },
      },
    ],
  },
];
